import { useIsMobile } from '@components/common/IsMobile/useIsMobile'
import React, { Fragment, useMemo } from 'react'
import { BreadcrumbItem } from './BreadcrumbItem'
import type { RequiredCategoryBreadcrumbsProps } from './Breadcrumbs'

export const BreadcrumbsPLP = (
    props: RequiredCategoryBreadcrumbsProps
): JSX.Element => {
    const { category, rootText, urlSuffix, urlPrefix } = props
    const isMobile = useIsMobile()

    const hideRootBreadcrumb = useMemo(() => {
        const len = category?.breadcrumbs?.length || 0
        if (isMobile && len > 1) return len
        return 0
    }, [isMobile, category?.breadcrumbs])

    const breadCrumbs = useMemo(() => {
        if (!category?.breadcrumbs || !hideRootBreadcrumb)
            return category.breadcrumbs
        return category.breadcrumbs.slice(hideRootBreadcrumb - 2)
    }, [hideRootBreadcrumb, category?.breadcrumbs])

    return (
        <div className="breadcrumbs">
            {!hideRootBreadcrumb && <BreadcrumbItem url="/" title={rootText} />}
            {breadCrumbs &&
                breadCrumbs.length &&
                breadCrumbs.map(
                    (
                        { category_url_key, category_url_path, category_name },
                        key
                    ) => (
                        <Fragment key={`item-${key}`}>
                            {hideRootBreadcrumb && key === 0
                                ? ''
                                : props.separator}
                            <BreadcrumbItem
                                key={`item-${key}`}
                                url={`${urlPrefix}/${
                                    category_url_path
                                        ? category_url_path
                                        : category_url_key
                                }${urlSuffix}`}
                                title={category_name}
                            />
                        </Fragment>
                    )
                )}
            {props.separator}
            <BreadcrumbItem title={category.name} active />
        </div>
    )
}
